<template>
  <div class="clearfix headerTag">
    <a v-if="headerData.isBackShow" class="fl back" href="javascript:history.go(-1)">返回</a>
    <span>{{headerData.headerTxt}}</span>
    <a v-if="headerData.isEditShow" class="fr editBtn" @click="editUserInfo">编辑</a>
    <a v-if="headerData.isSaveShow" class="fr editBtn" @click="saveUserInfo">保存</a>
  </div>
</template>
<style scoped lang="less">
@import url('../../assets/less/common.less');
.headerTag{
  padding:0 0.4rem;
  text-align: center;
  height: 1.173333rem;
  line-height: 1.173333rem;
  color: #222;
  .px2px(font-size,36px);
  background: #fff;
  border-bottom: 1px solid #ddd;
  .back{
    // float: left;
    position: absolute;
    left: 10px;
    height: 1.173333rem;
    width:1.106667rem;
    background: url('../../assets/img/common/arror.png');
    background-size:100% 100%;
    text-indent: -99999px;
  }
  .editBtn{
    position: absolute;
    right: 10px;
    height: 1.173333rem;
    width:1.106667rem;
    .px2px(font-size,30px);
    border:none;
    background: none;
    // color: #00a0e9;
  }
}
</style>
<script>
  import { Toast } from 'mint-ui';
  export default {
    name: 'comparison',
    data:function() {
      return {
      }
    },
    // props:["headerTxt","isButtonShow"],
    props:["headerData"],
    mounted: function() {
    },
    methods: {
      saveUserInfo:function(){
        this.$emit('childSaveUserInfo');
      },
      editUserInfo:function(){
        var btnShow = {
          userInfoExist:false,
          isEditShow:false,
          isSaveShow:true,
          phoneIsExist:false
        }
        localStorage.setItem('btnShow',JSON.stringify(btnShow));
        this.$router.push('/mapply/violationindex');
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/violation/header.vue